export default "__VITE_ASSET__DuQljec2__"